<div class="error-card">
  <span class="accent-bar"></span>

  <div class="error-icon-badge">
    <mat-icon aria-hidden="true">error_outline</mat-icon>
  </div>

  <p class="error-eyebrow">Something went wrong</p>
  <h2 class="error-title">{{ error.friendlyName }}</h2>

  @if (error.actionText) {
    <button type="button" class="error-action tbp" (click)="triggerErrorAction()">
      {{ error.actionText }}
    </button>
  }

  @if (id) {
    <div class="tech-details">
      <button type="button" class="tech-toggle" (click)="toggleTechnicalDetailsPane()"
              [attr.aria-expanded]="technicalDetailsPanelOpen()">
        <span>Technical details</span>
        <mat-icon aria-hidden="true">{{ technicalDetailsPanelOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      @if (technicalDetailsPanelOpen()) {
        <div class="tech-body">
          <p class="tech-hint">Share this reference code with Highfield support so we can investigate.</p>
          <div class="code-row">
            <code class="code">{{ id }}</code>
            <button type="button" class="copy-btn tbs"
                    [matTooltip]="tooltipText()" matTooltipPosition="above"
                    (click)="copy($event)" (mouseout)="setTooltipTextDefault()">
              <mat-icon aria-hidden="true">content_copy</mat-icon>
              <span>Copy</span>
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
